import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { truncateString } from 'services/utils/stringUtility';

const PieChart = ({ label = '', onEvent = () => {}, dataList = [] }) => {
  const [selectIndex, setSelectIndex] = useState(null);

  const colorsList = [
    //'#00ffe5',
    '#075985',
    '#0284c3',
    '#0C4A6E',
    '#7DD3FC',
    '#0284c7',
    '#49a5e9',
  ];

  const onData = (value) => {
    setSelectIndex(value);
    onEvent(dataList[value].name);
  };

  const validDataList = dataList.filter(
    (data) => data && data.name && typeof data.count === 'number'
  );

  const series = map(validDataList, (data) => data.count);
  const labelList = map(validDataList, (data) => data.name);

  const data = {
    labels: labelList,
    states: { hover: { filter: 'none' } },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: 'bottom',
      offsetY: 0,
      height: 50,
      show: true,
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: function (seriesName, opts) {
        const index = opts.seriesIndex;
        const count = validDataList[index].count;
        const fullName = validDataList[index].name;
        // Truncate legend labels
        return `${truncateString(fullName, 50)}: ${count}`;
      },
    },
    colors: labelList.map((_, index) =>
      selectIndex === index ? '#0284C7' : colorsList[index % colorsList.length]
    ),
    chart: {
      selection: { enabled: false },
      events: {
        dataPointSelection: (event, chartContext, config) =>
          setTimeout(() => onData(config?.dataPointIndex), 0),
      },
      type: 'pie',
    },
    stroke: { show: true, width: 1 },
    dropShadow: { enabled: false },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: function (val, opts) {
          const fullName = labelList[opts.seriesIndex];
          // Show full name in tooltip
          return `${fullName}: ${val}`;
        },
        title: {
          formatter: function () {
            return '';
          },
        },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        dataLabels: {
          minAngleToShowLabel: 10,
        },
      },
    },
  };

  return (
    <div className="pie-chart-container">
      {label && <div className="grp-lbl">{label}</div>}
      <Chart
        options={data}
        series={series}
        type="pie"
        height={350}
        width="100%"
      />
    </div>
  );
};

PieChart.propTypes = {
  label: PropTypes.string,
  onEvent: PropTypes.func,
  dataList: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, count: PropTypes.number })
  ),
};

export default PieChart;
